/*
 * Rota types retired or duplicated as part of Halo 18637 (ADO #2366 / #2368).
 *
 * Interim client-side hide: [Diary].[RotaType] has no delete flag yet, so we
 * filter these out of the type pickers (NCAOverlay / TemplateCalendarOverlay)
 * until proper soft-delete support exists. Existing rotas/tasks already using
 * one of these still render correctly — this only affects the picker lists.
 */
export const HIDDEN_ROTA_TYPE_IDS = new Set([
    30, 36, 38, 40, 45, 46, 47, 48,
    56, 57, 58, 59, 62, 64, 65, 66, 67, 71,
])

export const isRotaTypeHidden = rotaTypeID => HIDDEN_ROTA_TYPE_IDS.has(rotaTypeID)
